import React, { useState } from "react";
import { useSelector } from "react-redux";
import "../../../assets/css/cms/Cms.css";
import { FaAngleDown, FaUserAlt } from "react-icons/fa";
import { AiOutlineUser, AiOutlineLogout } from "react-icons/ai";
import logoImageCms from "../../../assets/images/common/logo-blue.svg";
import Logout from "../../../pages/auth/logout"

const DesktopHeader = (props) => {
  const store = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const [logoutUser, setLogoutUser] = useState(false);
  // const [isOpen, setIsOpen] = useState(false)

  const handleLogout = () => {
    setLogoutUser(true)
  };

  return (
    <div className={"Dheader"}>
      <img src={logoImageCms} alt="logo" />
      <ul className={"header_list"}>
        <li className={"header_lists"}>
          <div className={"header_list_item"} onClick={() => setShow(!show)}>
            <span>
              <FaUserAlt />
            </span>
            {show && (
              <div className={"header_list_item_description"}>
                <ul className={"header_sublist"}>
                  <li className={"header_sublists"}>
                    <a href="#" className={"header_sublist_item"}>
                      <span>
                        <AiOutlineUser />
                      </span>{" "}
                      Hello {props.user && props.user.name}
                    </a>
                  </li>
                  <li className={"header_sublists"}>
                    <a className={"header_sublist_item"} 
                    onClick={() =>handleLogout()}>
                      <span className={"icon_logout"}>
                        <AiOutlineLogout />
                      </span>{" "}Logout 
                      </a>
                  </li>
                </ul>
              </div>
            )}
             {logoutUser && <Logout user={props.user} />}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default DesktopHeader;
